<div class="master-modal reviepw_items_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title"> Raise Request </h4>
        <div class="modal_close_btn">
          <span (click)="closeDialog('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <form class="form-section" [formGroup]="raiseSupportForm" (ngSubmit)="sendOrderSupportRequest()">
        <!-- Modal content-->
        <perfect-scrollbar class="modal-body-scrollbar">
          <div mat-dialog-content>
            <!-- Modal-Body -->
            <div class="modal-body">
              <!-- Reason-INPUT -->
              <div class="custom-form-group">
                <label class="custom-label" for="">Reason<span class="star" style="display: inline-block !important;">*</span></label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline">
                    <mat-select  formControlName="reason" placeholder="Enter reason">
                      <mat-option>
                        <ngx-mat-select-search
                          [formControl]="reasonFilterCtrl"
                          placeholderLabel="Find reason..."
                          noEntriesFoundLabel="No matching category found"
                        ></ngx-mat-select-search>
                      </mat-option>
                      <mat-option [value]="singleReason.name" *ngFor="let singleReason of filterSupportRequestReasonsList">
                        {{singleReason.name}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="reason.invalid && ( reason.dirty || reason.touched )">
                      <span>Please provide a valid reason</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- message-TEXT-AREA-->
              <div class="custom-form-group">
                <label class="custom-label fx-display" for=""> Message <span class="star" style="display: inline-block !important;">*</span> </label>
                <div class="custom-form-control">
                  <mat-form-field appearance="outline" class="w-100">
                    <textarea rows="5" cols="5" matInput formControlName="message"
                      placeholder="Enter your message" (focusout)="trimMe(message)"></textarea>
                    <mat-error *ngIf="message.invalid && ( message.dirty || message.touched )">
                      <span>Please provide a valid message</span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <!-- Attachments -->
              <div class="custom-form-group">
                <label class="custom-label fx-display" for=""> Attachments <span class="star">*</span></label>
                <div class="custom-form-control">
                  <app-file-upload  [fileInput]="attachments" type="IMAGE"></app-file-upload>
                  <mat-error *ngIf="attachments.invalid && ( attachments.dirty || attachments.touched )">
                    <span>Please provide attachments </span>
                  </mat-error>
                </div>
              </div>

            </div>
          </div>
        </perfect-scrollbar>
        <!-- Modal-Footer -->
        <div class="modal-footer">
          <div mat-dialog-actions class="modal_footer">
            <button mat-button (click)="closeDialog('no')" class="modal-cancel-btn modal-footer-btn">
              <span>Cancel</span>
            </button>
            <button type="submit" mat-button class="modal-save-btn global-btn modal-footer-btn">
              <span> Submit </span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
